import Vue from 'vue';
import ValidationWrapper from '@/validation/ValidationWrapper.vue';

import WorkTextField from '@/components/global_components/forms/WorkTextField';
import WorkDateField from '@/components/global_components/forms/WorkDateField';
import WorkDateYearField from '@/components/global_components/forms/WorkDateYearField';
import WorkAutocomplete from '@/components/global_components/forms/WorkAutocomplete';
import WorkAutocompleteLazy from '@/components/base_components/WorkAutocompleteLazy';
import WorkSelect from '@/components/global_components/forms/WorkSelect';
import WorkTreeview from '@/components/global_components/forms/WorkTreeview';
import WorkCheckbox from '@/components/global_components/forms/WorkCheckbox';
import WorkTextArea from '@/components/global_components/forms/WorkTextArea';
import WorkPasswordField from '@/components/global_components/forms/WorkPasswordField';
import WorkDecimalTextField from '@/components/global_components/forms/text_fields/WorkDecimalTextField';
import WorkNumberTextField from '@/components/global_components/forms/text_fields/WorkNumberTextField';
import WorkTimeField from '@/components/global_components/forms/WorkTimeField';
import WorkUploadZone from '@/components/global_components/forms/WorkUploadZone';
import WorkTemporalAmountField from '@/components/global_components/forms/WorkTemporalAmountField';
import WorkRadioGroup from '@/components/global_components/forms/WorkRadioGroup';
import WorkSwitch from '@/components/global_components/forms/WorkSwitch';
import WorkColorPicker from '@/components/global_components/forms/WorkColorPicker';
import WorkPercentageTextField from '@/components/global_components/forms/text_fields/WorkPercentageTextField';
import WorkCurrencyTextField from '@/components/global_components/forms/text_fields/WorkCurrencyTextField';
import WorkTextEditor from '@/components/base_components/editor/WorkTextEditor';

function createGlobalValidationComponent(name, component, mapProps = x => x, isFocusable = true) {
  Vue.component(name, {
    extends: ValidationWrapper,
    data() {
      return {
        component,
        mapProps,
        isFocusable
      }
    }
  });
}

function propagateErrors(slotProps) {
  return { errorMessages: slotProps.errors, required: slotProps.required };
}

createGlobalValidationComponent('WFormTextField', WorkTextField, propagateErrors);
createGlobalValidationComponent('WFormTimeField', WorkTimeField, propagateErrors);
createGlobalValidationComponent('WFormDateField', WorkDateField, propagateErrors);
createGlobalValidationComponent('WFormDecimalTextField', WorkDecimalTextField, propagateErrors);
createGlobalValidationComponent('WFormNumberTextField', WorkNumberTextField, propagateErrors);
createGlobalValidationComponent('WFormDateYearField', WorkDateYearField, propagateErrors);
createGlobalValidationComponent('WFormSelect', WorkSelect, propagateErrors);
createGlobalValidationComponent('WFormCheckbox', WorkCheckbox, propagateErrors);
createGlobalValidationComponent('WFormAutocomplete', WorkAutocomplete, propagateErrors);
createGlobalValidationComponent('WFormAutocompleteLazy', WorkAutocompleteLazy, propagateErrors);
createGlobalValidationComponent('WFormSwitch', WorkSwitch, propagateErrors);
createGlobalValidationComponent('WFormTextArea', WorkTextArea, propagateErrors);
createGlobalValidationComponent('WFormUploadZone', WorkUploadZone, propagateErrors);
createGlobalValidationComponent('WFormTimeAmountField', WorkTemporalAmountField, propagateErrors);
createGlobalValidationComponent('WFormRadioGroup', WorkRadioGroup, propagateErrors);
createGlobalValidationComponent('WFormColorPicker', WorkColorPicker, propagateErrors);
createGlobalValidationComponent('WFormTreeview', WorkTreeview, propagateErrors);
createGlobalValidationComponent('WFormCurrencyField', WorkCurrencyTextField, propagateErrors);
createGlobalValidationComponent('WFormPercentageField', WorkPercentageTextField, propagateErrors);
createGlobalValidationComponent('WFormTextEditor', WorkTextEditor, propagateErrors);
createGlobalValidationComponent('WFormPasswordField', WorkPasswordField, propagateErrors);
